// removed by extract-text-webpack-plugin
module.exports = {"NoBuildings":"NoBuildings__NoBuildings___2kQBL","Rectangle":"NoBuildings__Rectangle___3XHg0","InfoTitle":"NoBuildings__InfoTitle___1cP29","InfoSubTitle":"NoBuildings__InfoSubTitle___2Gniv","Info":"NoBuildings__Info___3dNwB","Button":"NoBuildings__Button___XumWJ","Order":"NoBuildings__Order___3wd3y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buildings/NoBuildings/NoBuildings.scss
// module id = 1318
// module chunks = 0